import React from 'react';
import { Route } from 'react-router-dom';

interface IProps {
    path: string;
    component: React.FunctionComponent;
}

function ProtectedRoute({ path, component, ...props }: IProps) {
    return (
        <>
            <Route exact path={path} {...props} component={component} />
        </>
    );
}

const ProtectedRoutes = ProtectedRoute;
export default ProtectedRoutes;
